import { useMemo } from 'react'
import { useField } from 'react-final-form'
import { getFullName } from './helpers'
import { filterPrices, findPrice } from '../TimeRegistration2022Section/ConsultationPriceField'
import { Checkbox, TableCell, TableRow } from '@material-ui/core'
import { isValid } from 'date-fns'
import { nl } from 'date-fns/locale'
import { format } from 'date-fns'

type Option = { id: number; name?: string; value?: number }
type PriceLike = {
  value: string | number
  year?: number
  duration?: { id: number }
  consultationType?: { id: number }
  code?: string
}

//actually, the file/component name is misleading - it is not only for activities from 2022, but from all activities from 2022 forward
//todo - change naming thrpoughout the app
const InvoiceActivity2022Row = ({
  name,
  consultationTypes,
  psychologistOptions,
  durationOptions,
  prices,
  handleActivitySelect,
  isSelected
}: {
  name: string
  consultationTypes: Option[]
  psychologistOptions: any[]
  durationOptions: Option[]
  prices: PriceLike[]
  handleActivitySelect: (checked: boolean, payload: any) => void
  isSelected: boolean
}) => {
  const {
    input: { value: activity }
  } = useField(name)

  const {
    input: { value: treatmentType }
  } = useField('treatmentType')

  const consultationType = useMemo(
    () =>
      consultationTypes?.find((el: Option) => el.id === activity?.consultationType?.id)
        ?.name,
    [consultationTypes, activity?.consultationType?.id]
  )

  const psychologist = useMemo(() => {
    const psychologistObject = psychologistOptions?.find(
      (el: any) => el.id === activity?.psychologist?.id
    )
    const formattedPsychologist =
      psychologistObject && getFullName(psychologistObject)
    return formattedPsychologist
  }, [psychologistOptions, activity?.psychologist?.id])

  const duration = useMemo(() => {
    const durationObject = durationOptions?.find(
      (el: Option) => el.id === activity?.duration?.id
    )
    return durationObject?.value
  }, [durationOptions, activity?.duration?.id])

  const consultationPrice = useMemo(() => {
    const empty = { value: '0' }
    if (!prices) return empty
    // Use the same year-aware selection as time registration
    const price = findPrice(prices as any, activity as any, treatmentType as any)
    if (!price) return empty
    return price
  }, [prices, activity, treatmentType])

  const formattedDate = useMemo(() => {
    if (!activity?.date) return ''
    const date = new Date(activity.date)
    if (!isValid(new Date(date))) return ''
    return format(new Date(date), 'Pp', {
      locale: nl
    })
  }, [activity?.date])

  // @ts-ignore
  return (
    <>
      {activity?.id && (
        <TableRow>
          <TableCell>
            <Checkbox
              color="primary"
              disabled={
                !!activity.invoiceRow ||
                !activity?.date ||
                !consultationType ||
                typeof duration === 'undefined' ||
                !psychologist ||
                !consultationPrice.value
              }
              onChange={(e) =>
                handleActivitySelect(e.target.checked, {
                  id: activity.id,
                  date: activity.date,
                  amount: consultationPrice.value,
                  name,
                  description: `${consultationType} (${duration} min.)`
                })
              }
              checked={isSelected}
            />
          </TableCell>
          <TableCell>{formattedDate}</TableCell>
          <TableCell>{consultationType}</TableCell>
          <TableCell>{psychologist}</TableCell>
          <TableCell>{duration}</TableCell>
          <TableCell>{consultationPrice.value}</TableCell>
          <TableCell style={{ textAlign: 'center' }}>
            <Checkbox disabled checked={!!activity.invoiceRow} />
          </TableCell>
        </TableRow>
      )}
    </>
  )
}
export default InvoiceActivity2022Row
